import {
    PATIENTS_DATA_IS_ERROR,
    PATIENTS_DATA_IS_GET,
    PATIENTS_DATA_IS_LOGIN,
    PATIENTS_DATA_IS_EDIT
} from "../../actions/patients/patientsAction";

const initialData = {
    initialData: null,
    formData: null,
    isLoading: false,
    isError: false
};

export function patientsReducer(state = initialData, action) {
    switch (action.type) {
        case PATIENTS_DATA_IS_LOGIN:
            return {...state, isLoading: true, isError: false};
        case PATIENTS_DATA_IS_ERROR:
            return {...state, isLoading: false, isError: true};
        case PATIENTS_DATA_IS_GET:
            return {...state, isLoading: false, isError: false, initialData: action.payload};
        case PATIENTS_DATA_IS_EDIT:
            return {...state, isLoading: false, isError: false, formData: action.payload};
        default:
            return state;
    }
}
